export const initHeaderNav = () => {
  const toggleElement = document.querySelector("#header .navbar-toggle") as HTMLButtonElement;
  const maskElement = document.querySelector("#header .nav-mask") as HTMLDivElement;
  const btnClose = document.querySelector("#header .button-close") as HTMLButtonElement;

  if (!toggleElement || !maskElement || !btnClose) {
    return;
  }

  toggleElement.addEventListener("click", navBarToggle);

  function navBarToggle(e: Event) {
    e.preventDefault();

    document.body.classList.add("navbarvisible");
  }

  maskElement.addEventListener("click", navMaskClick);
  btnClose.addEventListener("click", navMaskClick);

  function navMaskClick(e: Event) {
    e.preventDefault();

    document.body.classList.remove("navbarvisible");
    document.body.classList.add("navbarhidden");

    // For smooth transitions between screensizes remove narbarhidden class after 0.4 seconds
    setTimeout(() => {
      document.body.classList.remove("navbarhidden");
    }, 400);
  }
};
